import axios, { AxiosResponse } from "axios";
import { WebAPI, IFailCallbackParam } from "../constants";
import { getErrorStatus } from "./getErrorStatus";
import AuthService from "../../common/AuthService";

interface ICallbackParams extends IFailCallbackParam {
  /**
   * WebAPIで通知既読の設定が成功した場合に呼び出されます
   * @callback success
   * @param {number} status - httpステータス
   */
  success: (status: number) => void;
}

function AxiosPost(url: string, noticeids: string[], token?: string) {
  if (token) {
    return axios.post(url, JSON.stringify(noticeids), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
  } else {
    return axios.post(url, JSON.stringify(noticeids), {
      headers: { "Content-Type": "application/json" },
    });
  }
}

interface IAxiosInternalParams extends ICallbackParams {
  promise: Promise<AxiosResponse>;
}

function AxiosInternal(params: IAxiosInternalParams) {
  params.promise
    .then((res) => {
      params.success(res.status);
    })
    .catch((err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    });
}

export interface ISetNoticesReadParams extends ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
  /**
   * 既読にする通知IDの配列
   */
  noticeids: string[];
}

/**
 * 通知の既読を設定します
 * @function setNoticesRead
 * @param {ISetNoticesReadParams} params - 通知既読設定パラメータ
 */
export function setNoticesRead(params: ISetNoticesReadParams): void {
  const { authService, noticeids } = params;
  const url = WebAPI.SET_NOTICES_READ;
  if (authService) {
    authService.getToken({
      success: (token) => {
        AxiosInternal({
          promise: AxiosPost(url, noticeids, token),
          success: params.success,
          fail: (id, status) => {
            if (status === 401) {
              setNoticesReadRetry401(authService, url, noticeids, params);
            } else {
              params.fail(id, status);
            }
          },
        });
      },
      fail: (err) => {
        const { id, status } = getErrorStatus(err);
        params.fail(id, status);
      },
    });
  } else {
    AxiosInternal({
      promise: AxiosPost(url, noticeids),
      success: params.success,
      fail: params.fail,
    });
  }
}

/**
 * 通知の既読を設定します
 * @function setNoticesReadRetry401
 * @param {AuthService} authService - 認証オブジェクト
 * @param {string} url - リクエストURL
 * @param {string[]} noticeids - 既読にする通知IDの配列
 * @param {ICallbackParams} params - コールバックパラメータ
 */
export function setNoticesReadRetry401(
  authService: AuthService,
  url: string,
  noticeids: string[],
  params: ICallbackParams
): void {
  authService.updateToken({
    success: (token) => {
      AxiosInternal({
        promise: AxiosPost(url, noticeids, token),
        success: params.success,
        fail: params.fail,
      });
    },
    fail: (err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    },
  });
}
